import React, { PropTypes } from 'react'
import { Collapse } from 'react-collapse'
import { presets } from 'react-motion'
import Sticky from 'react-stickynode'

import Section from './Section'

import { isMobile, isDesktop } from '../lib/responsive'

const MOBILE_MIN_HEIGHT = 200
const DESKTOP_MIN_HEIGHT = 425

const getStyles = ({ align, expanded, minHeight }) => ({
  root: {
    background: '#FFF',
  },
  collapse: {
    minHeight: isDesktop() ? DESKTOP_MIN_HEIGHT : MOBILE_MIN_HEIGHT,
    overflow: 'visible'
  },
  shadow: {
    boxShadow: !expanded && isMobile() && '0 -6px 8px rgba(0,0,0,0.05) inset',
    position: 'absolute',
    bottom: 0,
    left: 0,
    right: 0,
    height: 30,
    zIndex: 100
  },
  inner: {
    display: 'flex',
    alignItems: isMobile() ? 'center' : 'flex-start',
    justifyContent: 'space-between',
    flexDirection: isMobile() ? 'column' : (align === 'right' ? 'row' : 'row-reverse'),
  },
  image: {},
  description: {
    display: 'inline-block',
    width: isDesktop() ? 400 : '100%',
    margin: 0,
    paddingLeft: isMobile() && 30,
    paddingRight: isMobile() && 30,
  },
  descriptionInner: {
    paddingTop: 30
  }
})

const PortfolioItem = (props) => {
  const {
    image,
    children,
    align,
    expanded,
    id,
    stickyDescription,
    minHeight,
    springConfig,
    style,
    ...rest
  } = props
  const styles = getStyles(props)
  const stickId = `sticky-container-${id}`

  return (
    <div style={{ ...styles.root, ...style }} id={id} {...rest}>
      <Collapse
        isOpened={expanded || isMobile()}
        style={styles.collapse}
        springConfig={springConfig}
      >
        <Section>
          <div style={styles.inner} id={stickId}>
            <div style={styles.image}>
              { image }
            </div>
            <div style={styles.description}>
              <Sticky
                enabled={stickyDescription && !isMobile()}
                topBoundary={0}
                bottomBoundary={`#${stickId}`}
              >
                <div style={styles.descriptionInner}>
                  { children }
                </div>
              </Sticky>
            </div>
          </div>
        </Section>
        <div style={styles.shadow}></div>
      </Collapse>
    </div>
  )
}

PortfolioItem.propTypes = {
  id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  children: PropTypes.any,
  image: PropTypes.node,
  expanded: PropTypes.bool,
  stickyDescription: PropTypes.bool,
  align: PropTypes.oneOf(['left', 'right']),
}

PortfolioItem.defaultProps = {
  expanded: false,
  stickyDescription: true,
  align: 'left',
  springConfig: { stiffness: 90, damping: 16 }
}

export default PortfolioItem



// WEBPACK FOOTER //
// ./src/components/PortfolioItem.js